import {Route} from 'react-router'
import {NotFoundComponent} from '@freckle/school/ts/common/components/not-found'
import LoggedRoute from '@freckle/school/ts/common/routers/logged-route'
import RedirectAuthenticatedComponentHandler from '@freckle/school/ts/common/routers/redirect-authenticated'
import {AppSelectionPage} from '@freckle/school/ts/pages/app-selection-page'
import Expired from '@freckle/school/ts/pages/expired'
import {ForgotPasswordContainer} from '@freckle/school/ts/pages/forgot-password'
import Login from '@freckle/school/ts/pages/login'
import NoSchools from '@freckle/school/ts/pages/no-schools'
import {SetPasswordContainer as SetPassword} from '@freckle/school/ts/pages/set-password'
import SettingsComponentHandler from '@freckle/school/ts/settings/components'

export default function RouterV2Common() {
  return (
    <>
      <Route
        path="/redirect-authenticated"
        element={<LoggedRoute component={RedirectAuthenticatedComponentHandler} />}
      />
      <Route
        path="/app-selection"
        element={<LoggedRoute component={AppSelectionPage} fullScreen />}
      />
      <Route path="/settings" element={<LoggedRoute component={SettingsComponentHandler} />} />
      <Route path="/no-schools" element={<LoggedRoute component={NoSchools} fullScreen />} />
      <Route path="/expired" element={<Expired />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPasswordContainer />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/not-found" element={<NotFoundComponent />} />
    </>
  )
}
